import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

// Last-resort catch for render errors: without it an uncaught throw blanks the
// whole app. Mounted around the route tree keyed on the pathname (App.tsx), so
// navigating away from a crashed page remounts a fresh boundary.
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("Unhandled render error", error, info);
  }

  render(): ReactNode {
    if (!this.state.error) {
      return this.props.children;
    }
    return (
      <div className="full-center">
        <div className="app-card">
          <div className="error-notice" role="alert">
            <i className="fas fa-triangle-exclamation" aria-hidden="true" />
            <span>Something went wrong displaying this page.</span>
          </div>
          <button className="btn-primary-glow" onClick={() => window.location.reload()}>
            Reload
          </button>
        </div>
      </div>
    );
  }
}
